import { IZoomControl, IZoomArguments } from "./zoom-control-interface";
import { Quick3DPerspectiveCamera } from "../../quick3d-perspective-camera";
import { Vector3, Quaternion } from "three";

export interface IPerspectiveFixedPointZoomArguments extends IZoomArguments {
  ndcPointX?: number;
  ndcPointY?: number;
}

export class PerspectiveFixedPointZoomControl implements IZoomControl {
  private cameraQuaternion: Quaternion;
  private positionDelta: Vector3;

  public constructor() {
    this.cameraQuaternion = new Quaternion();
    this.positionDelta = new Vector3();
  }

  public zoom(
    camera: Quick3DPerspectiveCamera,
    zoomArguments: IPerspectiveFixedPointZoomArguments = {}
  ): void {
    const {
      zoomDirection = 1,
      zoomStep = 1,
      ndcPointX = 0,
      ndcPointY = 0,
    } = zoomArguments;

    const pointNear = new Vector3(0, 0, 0).unproject(camera);
    const pointFar = new Vector3(ndcPointX, ndcPointY, 1).unproject(camera);

    // if we zoomed in, new position is closer to camera. if we zoomed out, new position is further away
    this.positionDelta
      .subVectors(pointFar, pointNear)
      .setLength(zoomStep * zoomDirection);
    camera.getWorldQuaternion(this.cameraQuaternion).invert();
    camera.position.add(this.positionDelta);
    camera.updateMatrix();
  }
}
